import { CancellationReason } from '@therame/shared';

/**
 * German labels for the reasons a patient may give for an Absage (#1334). The
 * patient picks one in the cancel modal; the therapist reads it back on the
 * in-app notification (TM-9535).
 */
export const CANCELLATION_REASON_LABELS: Record<CancellationReason, string> = {
  [CancellationReason.ILLNESS]: 'Krankheit',
  [CancellationReason.SCHEDULE_CONFLICT]: 'Terminkonflikt',
  [CancellationReason.ABSENCE]: 'Abwesenheit',
  [CancellationReason.OTHER]: 'Sonstiges',
};
